import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Close from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import CheckCircle from '../../Icons/CheckCircle';
import Button from 'material-ui/Button';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

const styles = () => ({
  root: {
    background: "#040E35",
    position: 'absolute',
    top: 15,
    right: 15,
    width: '346px',
    '-webkit-box-shadow': '0px 5px 20px 0px rgba(0,0,0,0.38)',
    '-moz-box-shadow': '0px 5px 20px 0px rgba(0,0,0,0.38)',
    boxShadow: '0px 5px 20px 0px rgba(0,0,0,0.38)',
    padding: '20px',
    zIndex: 999,
  },

  iconButton: {
    position: 'absolute',
    right: 5,
    top: 5,
    color: 'white',
    width: 'unset',
    height: 'unset',
  },

  row: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid #232941',
    alignItems: 'flex-start',
    textAlign: 'left',
    paddingBottom: '15px',
  },

  content: {
    margin: '15px 0px',
    display: 'flex',
  },

  inline: {
    display: 'inline-flex',
    alignItems: 'center',
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '15px',
    width: '100%',
    justifyContent: 'flex-end',
  },

  button: {
    border: "1px solid #FFFFFF",
    color: '#FFFFFF',
    marginLeft: '20px',
    fontSize: '11px',
    height: '30px',
    minHeight: 'unset',
    padding: '6px 15px',
  },

  link: {
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(90, 91, 98, 0.2)",
    },
  },
});

class InfoBox extends React.Component {
  state = {
    checked: false,
  }

  handleCheck = () => {
    this.setState({ checked: !this.state.checked });
  }

  handleClose = () => {
    if (this.state.checked) {
      const intervalYear = 2;
      this.props.cookies.set('showSendLetterInfoBox', 0, { path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + intervalYear)) });
    }

    this.props.toggleDialog();
  }

  renderWithCheckCircle = (text) => {
    const { classes } = this.props;

    return (
      <div className={classes.inline}>
        <CheckCircle color="#33F084" width={15} height={15} />
        <Typography variant="body1" style={{ color: '#FFFFFF', marginRight: '5px', lineHeight: '19px' }}> {text}</Typography>
      </div>
    )
  }

  render() {
    const { toggleDialog, classes } = this.props;

    return (
      <div className={classes.root}>
        <IconButton onClick={toggleDialog} className={classes.iconButton}>
          <Close color="inherit" style={{ width: '16px', height: '16px' }} />
        </IconButton>

        <div className={classes.row}>
          <Typography variant="body2" style={{ color: '#FFFFFF', fontWeight: 'bold' }}> レター作成ガイドが 2021/05/28(金) に更新されました。</Typography>

          <div className={classes.content}>
            <Typography variant="body1" style={{ color: '#FFFFFF', lineHeight: '19px' }}>
              ご注文の前に
              <a
                href={process.env.REACT_APP_KEYMAN_LETTER_TEMPLATE_GUIDE_URL}
                target="_blank"
                className={classes.link}
              >
                レター作成ガイド
              </a>
              をご一読くださいませ。
            </Typography>
          </div>
        </div>

        <div className={classes.footer}>
          <div className={classNames(classes.inline, 'clickable')} onClick={this.handleCheck}>
            <input
              type="checkbox"
              checked={this.state.checked}
              onChange={this.handleCheck} />

            <Typography variant="body1" style={{ color: "#FFFFFF" }}>
              次回から表示しない
            </Typography>
          </div>

          <Button onClick={this.handleClose} className={classes.button}>了解です</Button>
        </div>
      </div>
    );
  }
}

InfoBox.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  toggleDialog: PropTypes.func.isRequired,
  cookies: instanceOf(Cookies).isRequired,
};

InfoBox.defaultProps = {
}


export default withCookies(withStyles(styles)(InfoBox));



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/InfoBox.jsx